// Web implementation of masked view.
const MaskStyle: React.CSSProperties = {
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    WebkitMaskSize: 'cover',
    maskSize: 'cover',
    position: 'relative',
    width: '100%',
    height: '100%',
    objectFit: 'cover', // Ensures the mask image fills the area without being cut off
};

export type MaskedViewProps = { imageUrl: string; children: React.ReactNode; style: Record<string, any> };

export function MaskedView({ imageUrl, children, style }: MaskedViewProps) {
    return (
        <div
            style={{
                ...MaskStyle,
                WebkitMaskImage: `url(${imageUrl})`,
                maskImage: `url(${imageUrl})`,
                ...style,
            }}
        >
            {children}
        </div>
    );
}
